import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Drawer from "@mui/material/Drawer";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import {
  Button,
  CardActionArea,
  CardContent,
  Divider,
  List,
  ListItem,
  Typography,
} from "@mui/material";
import DailySummary from "./DailySummary";
import { Transaction } from "../types";
import { financeCalculator } from "../utils/calcfncs";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { toCurrency } from "../utils/currency";
import { renderCategoryIcon } from "./common/Category";
import { RootState } from "../store/store";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

interface TransactionMenuProps {
  dailyTransactions: Transaction[];
  onAddTransactionForm: () => void;
  onSelectTransaction: (transaction: Transaction) => void;
  isDailyListWindowView: boolean;
  dailyListWindowView: () => void;
}

const TransactionMenu = ({
  dailyTransactions,
  onAddTransactionForm,
  onSelectTransaction,
  isDailyListWindowView,
  dailyListWindowView,
}: TransactionMenuProps) => {
  const { isMobile, currentDay } = useSelector((state: RootState) => state.app);
  // console.log(`TransactionMenu:${currentDay}:`, dailyTransactions);
  // console.log("isMobile:", isMobile);
  const balance = financeCalculator(dailyTransactions);
  const { t: tCommon } = useTranslation("common");

  return (
    <Drawer
      sx={{
        width: isMobile ? "auto" : "320px",
        "& .MuiDrawer-paper": {
          width: isMobile ? "auto" : "320px",
          boxSizing: "border-box",
          p: 2,
          top: isMobile ? 256 : 64,
          bottom: isMobile ? 0 : "auto",
          borderRadius: isMobile ? "10px 10px 0 0" : 0,
          height: isMobile ? "calc(100dvh - 256px)" : "calc(100vh - 64px)",
          display: "flex",
          flexDirection: "column",
          minHeight: 0,
          overflow: "hidden",
        },
      }}
      variant={isMobile ? "temporary" : "permanent"}
      anchor={isMobile ? "bottom" : "right"}
      open={isDailyListWindowView}
      onClose={dailyListWindowView}
      ModalProps={{
        keepMounted: true, // Better open performance on mobile.
      }}
    >
      <Stack sx={{ minHeight: 0, height: "100%" }}>
        <Typography sx={{ fontWeight: "fontWeightBold", mb: 1 }}>
          {tCommon("transaction.date")}：{currentDay}
        </Typography>

        <DailySummary dailyBalance={balance} />
        {/* 内訳タイトルと内訳追加ボタン*/}

        <Divider sx={{ mt: 2, mb: 2 }} />

        <Box>
          <Stack
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography sx={{ fontWeight: "fontWeightBold" }}>
              {tCommon("transaction.title")}
            </Typography>
            <Button
              sx={{
                display: "flex",
                flexDirection: "row",
                alignContent: "center",
              }}
              onClick={onAddTransactionForm}
            >
              <AddCircleIcon />
              <Typography sx={{ fontWeight: "fontWeightBold" }}>
                {tCommon("transaction.add")}
              </Typography>
            </Button>
          </Stack>
        </Box>

        {/* 内訳リスト　*/}
        <Box
          sx={{
            minHeight: 0,
            flex: "1 1 0",
            width: "100%",
            overflowY: "auto",
            pb: isMobile ? "env(safe-area-inset-bottom)" : 0,
          }}
        >
          <List arial-label="transaction-history">
            <Stack>
              {dailyTransactions.map((tr) => {
                return (
                  <ListItem
                    key={tr.id}
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      width: "100%",
                    }}
                  >
                    <Card
                      sx={{
                        width: "100%",
                        bgcolor: (theme) =>
                          tr.type === "income"
                            ? theme.palette.incomeColor.light
                            : theme.palette.expenseColor.light,
                      }}
                      onClick={() => onSelectTransaction(tr)}
                    >
                      <CardActionArea>
                        <CardContent>
                          <Grid container spacing={1}>
                            <Grid size={8}>
                              <Stack
                                sx={{
                                  display: "flex",
                                  flexDirection: "row",
                                  alignItems: "center",
                                }}
                              >
                                {renderCategoryIcon(tr.category)}
                                <Typography>{tr.category}</Typography>
                              </Stack>
                            </Grid>
                            <Grid size={4}>
                              <Typography sx={{ textAlign: "right" }}>
                                {toCurrency(tr.amount)}
                              </Typography>
                            </Grid>
                          </Grid>
                        </CardContent>
                      </CardActionArea>
                    </Card>
                  </ListItem>
                );
              })}
            </Stack>
          </List>
        </Box>
      </Stack>
    </Drawer>
    // <>
    //   <Stack sx={{ display: "flex", flexDirection: "row" }}>
    //     <Typography>日時：</Typography>
    //     <Typography>2024-04-11</Typography>
    //   </Stack>
    //   <Grid
    //     container
    //     spacing={2}
    //     sx={{ display: "flex", flexDirection: "row" }}
    //   >
    //     <Grid size={6}>
    //       <Card sx={{ bgcolor: "lightgrey" }}>収入 ¥3,000</Card>
    //     </Grid>
    //     <Grid size={6}>
    //       <Card sx={{ bgcolor: "lightgrey" }}>収入 ¥3,000</Card>
    //     </Grid>
    //     <Grid size={12}>
    //       <Card sx={{ bgcolor: "lightgrey" }}>収入 ¥3,000</Card>
    //     </Grid>
    //   </Grid>
    // </>
  );
};

export default TransactionMenu;
